module.exports = __webpack_public_path__ + "static/img/hy.d9522c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hy.jpg
// module id = IjdT
// module chunks = 1